import React from 'react';
import {Box, Divider, IconButton, Typography} from "@mui/material";
import Logo from "./Logo";
import LinkedInIcon from "@mui/icons-material/LinkedIn";

const DefaultFooter = () => {
    return (
        <Box display='flex' width='100%' sx={{
            backgroundColor: 'white',
        }}>
            <Box mx='50px' my='10px' width='100%'>
                <Box display='flex' width='100%' alignItems='center' justifyContent='space-between'>
                    <Box m='12px'>
                        <Logo/>
                    </Box>
                    <IconButton href='https://at.linkedin.com/in/leo-keiblinger-331447133'>
                        <LinkedInIcon sx={{color: '#0072b1'}}/>
                    </IconButton>
                </Box>
                <Divider/>
                <Typography variant="body1"
                            py='16px'
                            sx={{
                                fontSize: '16px',
                                fontWeight: '300',
                                letterSpacing: '.03rem',
                                lineHeight: '1.7rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}>
                    ©2022 Leopold Keiblinger. Alle Rechte vorbehalten.
                </Typography>
            </Box>
        </Box>
    )
}

export default DefaultFooter;